import { c as _c } from "react/compiler-runtime";
import { cn } from "cn";
import { m } from "motion/react";
import { useState } from "react";
import { AnimatedSubmitButton } from "@/components/common/animated-submit-button";
import { Textarea } from "@/components/ui/textarea";
import { slideBlurVariants, springTransitions } from "@/lib/animation-presets";
interface FeedbackFormProps {
  action: (formData: FormData) => void;
  error: string | null;
  pending: boolean;
}
export function FeedbackForm(t0) {
  const $ = _c(21);
  const {
    action,
    pending,
    error
  } = t0;
  const [message, setMessage] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <input aria-hidden="true" autoComplete="off" className="absolute top-[-9999px] left-[-9999px] h-0 w-0 opacity-0" name="website" tabIndex={-1} type="text" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = error ? "feedback-error" : undefined;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e => setMessage(e.target.value);
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== message || $[3] !== pending || $[4] !== t2) {
    t4 = <Textarea aria-describedby={t2} aria-label="Feedback message" className="min-h-0 flex-1 resize-none p-2 text-base sm:text-sm" disabled={pending} id="feedback-message" name="message" onChange={t3} onKeyDown={_temp} placeholder="Ideas, suggestions, or issues" value={message} />;
    $[2] = message;
    $[3] = pending;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = error ? "text-red-500 text-sm" : "sr-only";
  let t6;
  if ($[6] !== t5) {
    t6 = cn(t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== error || $[9] !== t6) {
    t7 = <p className={t6} id="feedback-error" role="status">{error}</p>;
    $[8] = error;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = !message.trim() || pending;
  let t9;
  if ($[11] !== pending || $[12] !== t8) {
    t9 = <AnimatedSubmitButton disabled={t8} isLoading={pending} label="Send Feedback" size="md" />;
    $[11] = pending;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t4 || $[15] !== t7 || $[16] !== t9) {
    t10 = <div className="flex h-full flex-col gap-2">{t1}{t4}{t7}{t9}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== action || $[19] !== t10) {
    t11 = <m.form action={action} className="h-full will-change-transform" key="form" transition={springTransitions.slower} {...slideBlurVariants}>{t10}</m.form>;
    $[18] = action;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
function _temp(e_0) {
  if (e_0.key === "Enter" && (e_0.metaKey || e_0.ctrlKey)) {
    e_0.preventDefault();
    e_0.currentTarget.form?.requestSubmit();
  }
}